import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  FormHelperText,
} from "@material-ui/core";

import { setWeightDistribution } from "../../../actions/app/creatives";
import { ROTATION_TYPES, WEIGHT_OPTIONS } from "../../../actions/app/constants";
import HelperTooltip from "../../Shared/HelperTooltip/HelperTooltip";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
  legend: {
    textAlign: "left",
  },
  helperText: {
    textAlign: "right",
    marginLeft: 32,
    marginTop: -6,
  },
}));

const AssetWeight = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const weightDistribution = useSelector(
    (state) => state.creatives.weightDistribution
  );
  const rotationType = useSelector((state) => state.creatives.rotationType);

  return (
    <div>
      <FormControl component="fieldset" className={classes.formControl}>
        <FormLabel component="legend" className={classes.legend}>
          Creative Weight
          <HelperTooltip tooltipText="Determines how often each creative in a rotation serves with your creative set. Note that percentages are rounded" />
        </FormLabel>
        <RadioGroup
          aria-label="weight"
          name="weight"
          value={weightDistribution}
          onChange={(e) => dispatch(setWeightDistribution(e.target.value))}
        >
          <FormControlLabel
            value={WEIGHT_OPTIONS.EVEN}
            control={<Radio />}
            label={
              <>
                Distribute Evenly
                <HelperTooltip tooltipText="In an even rotation, your creatives rotate evenly, and should all be served about the same number of times." />
              </>
            }
            disabled={rotationType !== ROTATION_TYPES.WEIGHTED}
          />
          <FormControlLabel
            value={WEIGHT_OPTIONS.CUSTOM}
            control={<Radio />}
            label={
              <>
                Custom
                <HelperTooltip tooltipText="In a custom rotation, you set your own weights for each creative. If a creative has a higher weight than the others, it gets served more often." />
              </>
            }
            disabled={rotationType !== ROTATION_TYPES.WEIGHTED}
          />
          <FormHelperText className={classes.helperText}>
            Update custom weights to the left
          </FormHelperText>
        </RadioGroup>
      </FormControl>
    </div>
  );
};

export default AssetWeight;
